import { UserActivation } from '@puzzlemania/audio';

/**
 * Module 57 — the app's one activation tracker.
 *
 * A single shared instance lives here, in the composition layer, for the same
 * reason `SettingsSaveModule` does: there is exactly one document, and both
 * entries plus both composition roots have to agree about whether it has been
 * touched. The class itself is state-free framework code in `packages/audio`;
 * this is the app deciding to have one of them.
 *
 * **Install it as the first statement of an entry, before any `await`.** That is
 * the entire fix: the CrazyGames embed's composition root runs behind
 * `await ensureCrazyGamesSdkReady()` — an `SDK.init()` round trip plus a poll,
 * bounded at 10 s — and the listeners used to be registered inside it. A player
 * who clicked during loading was never seen, so the background music stayed owed
 * until they touched the board, which is exactly the "music doesn't start until
 * I do something" report this module opened on.
 */
export const AppUserActivation = new UserActivation();

/** Start watching for the first gesture. Idempotent; no-op without a DOM. */
export function installUserActivation(): void {
  AppUserActivation.install();
}
